import React, { useCallback } from 'react'
import { rem } from 'polished'
import { fillArray } from 'lib/array/arrayUtils'
import styled from 'styled-components'
import { useIsMobileScreen } from 'lib/web/deviceUtils'
import useCruiseSearchFacets from 'hooks/Cruise/useCruiseSearchFacets'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Heading from 'components/Luxkit/Typography/Heading'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import Group from 'components/utils/Group'
import CruiseLinesSectionItem from './CruiseLinesSectionItem'

const ContentSkeleton = styled(LoadingBox)`
  width: 100%;
  border-radius: ${props => props.theme.borderRadius.M};
  height: ${rem(100)};
`

function CruisePageCruiseLinesCarousel() {
  const isMobileScreen = useIsMobileScreen()
  const itemsToShow = isMobileScreen ? 3 : 7
  const [cruiseLines, fetching] = useCruiseSearchFacets({ facetTypes: ['cruise_lines'] })

  const getItemLink = useCallback(({ name }: App.CruiseSearchFacet) => {
    const cruiseLineName = name?.toLowerCase().replace(/ /g, '-')
    return `/cruise-line/${cruiseLineName}`
  }, [])

  if (!cruiseLines?.length) {
    return null
  }

  return <Group direction="vertical" gap={20}>
    <Heading variant="heading3">
      Explore by featured <i> cruise lines</i>
    </Heading>

    <Group direction="vertical" gap={8}>
      <CardCarousel pageSize={itemsToShow} gap={12}>
        {cruiseLines?.map((cruiseLine) => <CruiseLinesSectionItem
          key={cruiseLine.imageId}
          cruiseLine={cruiseLine}
          to={getItemLink(cruiseLine)}
          isQuickFilter
        />)}
      </CardCarousel>

      {fetching &&
        <Group direction="horizontal" gap={16}>
          {fillArray(itemsToShow).map((id) => <ContentSkeleton key={id} />)}
        </Group>
      }
    </Group>
  </Group>
}

export default CruisePageCruiseLinesCarousel
